import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import { getOperatorByID } from "@/v1/services/operators";
import { setBreadcrumb } from "@/v1/store/app/actions";
import { UnauthorizedPage } from "@/v2/components/molecules/UnauthorizedPage/UnauthorizedPage";

interface SecureOperatorRouteProps {
  component: any;
}

const SecureOperatorRoute: FC<SecureOperatorRouteProps> = ({ component: Component }) => {
  const { operatorsID }: { operatorsID: string } = useParams();
  const [authorized, setAuthorized] = useState<boolean>();
  const dispatch = useDispatch();

  const checkIfAuthorized = async () => {
    try {
      await getOperatorByID(operatorsID);
      setAuthorized(true);
    } catch {
      setAuthorized(false);
    }
  };

  useEffect(() => {
    setBreadcrumb([])(dispatch);
    checkIfAuthorized();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operatorsID]);

  if (authorized === undefined) return null;

  if (authorized === false) return <UnauthorizedPage />;

  return <Component />;
};

export default SecureOperatorRoute;
